import * as React from 'react';

import { Divider } from '@mui/material';
import { useRegion } from 'common/hooks/region';
import { NotYetAvailable } from 'components/Badges';
import { Greeting } from 'components/Greeting';
import { RegionalWrapper } from 'layouts/AppPageTemplate/desktop/DesktopNav/RegionDropdown/RegionalWrapper';
import { Questions } from './Questions';

export const UnsupportedMessage: React.FC = () => {
  const region = useRegion();

  return (
    <div className="flex items-start flex-col space-y-4">
      <NotYetAvailable />
      <div className="space-y-4">
        <div className="space-y-4">
          <Greeting />
          <p>This feature is not yet available for the port of {region.name}.</p>
          <RegionalWrapper targetRegionKey="USLA">
            <p>Switch locations to Los Angeles / Long Beach to start using it!</p>
          </RegionalWrapper>
        </div>
        <Divider />
        <Questions />
      </div>
    </div>
  );
};
UnsupportedMessage.displayName = 'UnsupportedRegion.Message';
